'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';

class StatisticsMapStore {
  @observable center = { longitude: 120, latitude: 30 };
  @observable markers = [];
  @observable markerList = [];
  @observable showRightPanel = false;
  @observable location = { province: '', city: '' }; //位置信息 省市 经纬度
  @observable selectedCluster = [];

  @observable
  amapEvents = {
    created: amapInstance => {
      const { northeast, southwest } = amapInstance.getBounds();
      this.location.north = northeast.lat;
      this.location.south = southwest.lat;
      this.location.east = northeast.lng;
      this.location.west = southwest.lng;
      this.loadDevicePoints(this.location);
      amapInstance.on('zoomstart', () => {
        this.hideCluster();
      });
      amapInstance.on('zoomend', () => {
        this.handleMapWindowMove(amapInstance);
      });
      amapInstance.on('moveend', () => {
        this.handleMapWindowMove(amapInstance);
      });
    }
  };

  @action
  loadDevicePoints(location) {
    let param = buildUrl({
      square: location.east
        ? [location.east, location.south, location.west, location.north].join(
            ','
          )
        : ''
    });
    fetch(`/api/statistics/map${param}`, { method: 'GET' }, json => {
      if (json.length) {
        this.markers = json.map((item, index) => ({
          ...item,
          position: {
            longitude: item.longitude,
            latitude: item.latitude
          },
          index
        }));
      }
    });
  }
  @action
  hideCluster() {
    this.markers = [];
  }
  @action
  handleMapWindowMove(amap) {
    const { northeast, southwest } = amap.getBounds();
    this.location.north = northeast.lat;
    this.location.south = southwest.lat;
    this.location.east = northeast.lng;
    this.location.west = southwest.lng;
    this.loadDevicePoints(this.location);
  }
  @action.bound
  onMarkerClick(e) {
    if (e.markers && e.lnglat) {
      const markers = e.markers.map(item => ({
        ...item.getExtData()
      }));
      const markersOnline = markers.filter(p => p.online_status);
      const markersOffline = markers.filter(p => !p.online_status);
      this.markerList = markersOnline.concat(markersOffline);

      this.showRightPanel = true;
      this.center = { longitude: e.lnglat.lng, latitude: e.lnglat.lat };

      this.selectedCluster = e.markers.map(m => m.getExtData().device_id);
    }
    return false;
  }
}
export default new StatisticsMapStore();



// WEBPACK FOOTER //
// ./src/store/Statistics/StatisticsMap.js